import { useEffect, useRef, useState } from "react";
import { Layout } from "@/config/antd";
import { Header } from "@/components/layout/Header/Top_Bar";
import { Routes, Route, useNavigate } from "react-router-dom";
// import OfflineIndicator from '../ui/Offline_Indicator';

// Pages Import
import DashboardLayout from "./Dashboard_Layout";

import Overview from "@/pages/overview/Overview";

// Notification
import Notifications from "@/pages/notifications/Notifications";
import SingleNotification from "@/pages/notifications/SingleNotification";

// Event Management
import EventHome from "@/pages/event_management/event_home/Event_Home";
import AddEvent from "@/pages/event_management/add_new_event/Step_1_Add_New_Event";
import SingleCampaign from "@/pages/event_management/single_campaign/Single_Campaign";
import SingleSubEvent from "@/pages/event_management/single_sub_event/Single_Sub_Event";

// Sub Event Step Import
import AddSubEventLayout from "@/pages/event_management/add_sub_event/layouts/AddSubEventLayout";
import AddSubEventStep1 from "@/pages/event_management/add_sub_event/Step_1_Add_Sub_Event";
import AddSubEventStep2 from "@/pages/event_management/add_sub_event/Step_2_Add_Sub_Event";
import AddSubEventStep3 from "@/pages/event_management/add_sub_event/Step_3_Add_Sub_Event";

// Finance Manager
import FinancialManagerHome from "@/pages/finance_manager/single_financial_manager/Financial_Manager_Home";
import SingleFinancialManager from "@/pages/finance_manager/Single_Finacial_Manager";
import ExpenseForm from "@/pages/finance_manager/single_financial_manager/Expense_Form";
import AddFunds from "@/pages/finance_manager/single_financial_manager/Add_Funds";
import AccountManager from "@/pages/finance_manager/single_financial_manager/Account_Manager";
import DonationManager from "@/pages/finance_manager/single_financial_manager/Donation_Manager";

// Canvass
import CanvassHome from "@/pages/canvass/Canvass_Home";
import SingleCanvass from "@/pages/canvass/Single_Canvass";

// Town Hall
import TownHallHome from "@/pages/town_hall/Town_Hall_Home";
import SingleTownHall from "@/pages/town_hall/Single_Town_Hall";
import AddNewTownHall from "@/pages/town_hall/components/Add_New_Town_hall";

// Manifesto
import ManifestoHome from "@/pages/manifesto/Manifesto_Home";
import SingleManifesto from "@/pages/manifesto/Single_Manifesto";
import AddNewManifesto from "@/pages/manifesto/Add_New_Manifesto";

// Polls and Survey
import PollsAndSurveyHome from "@/pages/polls_&_survey/Polls_And_Survey_Home";
import SinglePollsAndSurvey from "@/pages/polls_&_survey/Single_Polls_And_Survey";
import PoliticalStance from "@/pages/polls_&_survey/Political_Stance";
import AddNewPollsAndSurvey from "@/pages/polls_&_survey/Add_New_Polls_And_Survey";

// Settings
import SettingsHome from "@/pages/settings/Settings_Home";
import GeneralSettings from "@/pages/settings/components/general_settings/General_Settings";
import OrganizationSettings from "@/pages/settings/components/manage_orgnization/Manage_Organization";
import VerificationSettings from "@/pages/settings/components/manage_kyc/Manage_Kyc";
// import NotificationSettings from '../pages/settings/Notification_Settings';
// import SocialSettings from '../pages/settings/Social_Settings';
// import ThemeSettings from '../pages/settings/Theme_Settings';
// import HelpSettings from '../pages/settings/Help_Settings';
// import LegalSettings from '../pages/settings/Legal_Settings'

// Media Manager
import MediaManagerHome from "@/pages/media_manager/Media_Manager_Home";

// User Management
import UserManagementHome from "@/pages/user_management/User_Management_Home";
import SingleUser from "@/pages/user_management/Single_User";

// Roles Management
import RolesManagementHome from "@/pages/roles_management/Roles_Management_Home";
import SingleRolesManagement from "@/pages/roles_management/Single_Roles_Management";
import AddRolesStep1 from "@/pages/roles_management/components/add_roles/Add_Roles_Step_1";
import AddRolesStep2 from "@/pages/roles_management/components/add_roles/Add_Roles_Step_2";
import AddRolesStep3 from "@/pages/roles_management/components/add_roles/Add_Roles_Step_3";

// FAQ
import FAQ from "@/pages/settings/components/FAQ/FAQ";

// Support
import SupportHome from "@/pages/support/Support_Home";
import SingleSupport from "@/pages/support/Single_Support";
import SettingsList from "@/pages/settings/SettingsList";
import CandidatePage from "@/pages/candidates/CandidatePage";
import AddRolesLayout from "@/pages/roles_management/components/add_roles/layout/AddRolesLayout";
import SearchResults from "@/pages/search/Search_Results";
import useNotificationsSocket from "@/hooks/useNotificationsSocket";
import FeedbackPrompt from "@/components/layout/FeedbackPrompt";
import useBrowserNotifications from "@/hooks/useBrowserNotifications";
import useOneSignal from "@/hooks/useOneSignal";
import { OneSignalContext } from "@/context/OneSignalContext";
const { Content } = Layout;

export const MainLayout = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();
  const [socketNotification, setSocketNotification] = useState(null);

  // Prompt for browser notification permission only after the user is logged in
  const { isSupported, permission, requestPermission } =
    useBrowserNotifications();
  const hasRequestedNotificationRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.IS_ELECTRON === true) return;
    if (!isSupported) return;
    if (hasRequestedNotificationRef.current) return;

    if (permission === "default") {
      
      hasRequestedNotificationRef.current = true;
      requestPermission();
    }
  }, [isSupported, permission, requestPermission]);

  // Initialize OneSignal for web push notifications.
  // isSubscribed / optIn / optOut are passed down via context so the
  // Notification Settings modal can toggle the subscription without prop-drilling.
  const oneSignal = useOneSignal();

  // Establish a single WebSocket connection for real-time notifications
  // once the user is inside the authenticated dashboard layout.
  useNotificationsSocket((payload) => {
   
    if (payload && Array.isArray(payload.data)) {
      setSocketNotification(payload.data[0]);
    } else if (payload) {
      setSocketNotification(payload);
    }
  });

  

  const handleMenuClick = (key) => {
    setMenuVisible(false);
    navigate(key);
  };

  return (
    // Provide OneSignal helpers (isSubscribed, optIn, optOut) to the entire
    // dashboard subtree so the Notification Settings modal can consume them.
    <OneSignalContext.Provider value={oneSignal}>
    <Layout
      className="min-h-screen transition-colors duration-200"
      style={{ backgroundColor: "var(--background-color)" }}>
      <Header
        menuVisible={menuVisible}
        setMenuVisible={setMenuVisible}
        onMenuClick={handleMenuClick}
        navigate={navigate}
        className="w-full sticky top-0"
      />
      <Content
        className="transition-colors duration-200"
        style={{ backgroundColor: "var(--background-color)" }}>
        <div className="h-full w-full px-3 sm:px-4 md:px-6 lg:px-8 relative">
          <FeedbackPrompt
            notification={socketNotification}
            onClose={() => setSocketNotification(null)}
          />
          <Routes>
            <Route element={<DashboardLayout />}>
              <Route path="/" element={<Overview />} />

              <Route path="notifications" element={<Notifications />} />
              <Route
                path="notifications/:id"
                element={<SingleNotification />}
              />

              {/* Event Management Routes */}
              <Route path="events" element={<EventHome />} />
              <Route path="events/add" element={<AddEvent />} />
              <Route path="events/edit/:id" element={<AddEvent />} />
              <Route path="events/:id" element={<SingleCampaign />} />
              <Route
                path="events/:eventId/schedule/:id"
                element={<SingleSubEvent />}
              />

              {/* Sub Event Step Routes */}
              <Route element={<AddSubEventLayout />}>
                <Route
                  path="events/:eventId/add-sub-event/step-1"
                  element={<AddSubEventStep1 />}
                />
                <Route
                  path="events/:eventId/add-sub-event/step-2"
                  element={<AddSubEventStep2 />}
                />
                <Route
                  path="events/:eventId/add-sub-event/step-3"
                  element={<AddSubEventStep3 />}
                />
              </Route>

              {/* Finance Manager Routes */}
              <Route path="financial" element={<FinancialManagerHome />} />
              <Route
                path="financial/transaction/:id"
                element={<SingleFinancialManager />}
              />
              <Route path="financial/add-expense" element={<ExpenseForm />} />
              <Route path="financial/edit/:id" element={<ExpenseForm />} />
              <Route path="financial/add-funds" element={<AddFunds />} />
              <Route path="financial/account" element={<AccountManager />} />
              <Route path="financial/donations" element={<DonationManager />} />

              {/* Candidates Routes */}
              {/* <Route path="candidates" element={<CandidatesHome />}>
                
              </Route> */}

              <Route path="candidates" element={<CandidatePage />} />
              <Route path="candidates/:id" element={<CandidatePage />} />

              {/* Canvass Routes */}
              <Route path="canvass" element={<CanvassHome />} />
              <Route path="canvass/:id" element={<SingleCanvass />} />

              {/* <Route path="candidates:id" element={<SingleCandidate />} /> */}

              {/* Town Hall Routes */}
              <Route path="townhall" element={<TownHallHome />} />
              <Route path="townhall/:id" element={<SingleTownHall />} />
              <Route path="townhall/add" element={<AddNewTownHall />} />
              <Route path="townhall/edit/:id" element={<AddNewTownHall />} />

              {/* Manifesto Routes */}
              <Route path="manifesto" element={<ManifestoHome />} />
              <Route path="manifesto/add" element={<AddNewManifesto />} />
              <Route path="manifesto/edit/:id" element={<AddNewManifesto />} />
              <Route path="manifesto/:id" element={<SingleManifesto />} />

              {/* Polls and Survey Routes */}
              <Route path="polls" element={<PollsAndSurveyHome />} />
              <Route path="polls/:id" element={<SinglePollsAndSurvey />} />
              <Route
                path="polls/political-stance/:id"
                element={<PoliticalStance />}
              />
              <Route path="polls/add" element={<AddNewPollsAndSurvey />} />
              <Route path="polls/edit/:id" element={<AddNewPollsAndSurvey />} />

              {/* Settings Routes */}
              <Route path="settings" element={<SettingsHome />} />
              <Route path="settings" element={<SettingsList />}>
                <Route path="general" element={<GeneralSettings />} />
                <Route path="organization" element={<OrganizationSettings />} />
                <Route path="verification" element={<VerificationSettings />} />
              </Route>

              {/* Media Manager Routes */}
              <Route path="media" element={<MediaManagerHome />} />

              {/* User Management Routes */}
              <Route path="users" element={<UserManagementHome />} />
              <Route path="users/:id" element={<SingleUser />} />

              {/* Roles Management Routes */}
              <Route path="roles" element={<RolesManagementHome />} />
              <Route path="roles/:id" element={<SingleRolesManagement />} />
              <Route element={<AddRolesLayout />}>
                <Route
                  path="roles/add-roles-step-1"
                  element={<AddRolesStep1 />}
                />
                <Route
                  path="roles/add-roles-step-2"
                  element={<AddRolesStep2 />}
                />
                <Route
                  path="roles/add-roles-step-3"
                  element={<AddRolesStep3 />}
                />
                <Route
                  path="roles/edit/:id/step-1"
                  element={<AddRolesStep1 />}
                />
                <Route
                  path="roles/edit/:id/step-2"
                  element={<AddRolesStep2 />}
                />
                <Route
                  path="roles/edit/:id/step-3"
                  element={<AddRolesStep3 />}
                />
              </Route>

              {/* FAQ Routes */}
              <Route path="settings/help/faq/support" element={<FAQ />} />

              {/* Support Routes */}
              <Route path="settings/support" element={<SupportHome />} />
              <Route path="settings/support/:id" element={<SingleSupport />} />

              {/* Global Search Results Route */}
              <Route path="search" element={<SearchResults />} />

              {/* <Route path="*" element={<Navigate to="overview" replace />} /> */}
            </Route>
          </Routes>
        </div>
      </Content>
      {/* <OfflineIndicator /> */}
    </Layout>
    </OneSignalContext.Provider>
  );
};
